module.exports = __webpack_public_path__ + "static/media/lifestyle3-small.632f83a9.jpg";